/* stats/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const CountNameType = t.type({
  count: t.number,
  name: t.union([t.string, t.null]),
});

const DataCodec = t.intersection([
  t.type({
    totals: t.type({
      totalMerchant: t.number,
      totalPOS: t.number,
      totalTerminal: t.number,
      totalTerminalConfigured: t.number,
      totalProcessor: t.number,
      totalStagedTerminal: t.number,
      totalSuspendedTerminal: t.number,
    }),
    terminalStats: t.type({
      integratedTerminal: t.number,
      standaloneTerminal: t.number,
      softwareInUse: t.array(CountNameType),
      topCpats: t.array(CountNameType),
      topEmvs: t.array(CountNameType),
    }),
  }),
  t.partial({}),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const StatsCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "StatsCodec"
);

export type Stats = t.TypeOf<typeof StatsCodec>;

export enum StatsActionTypes {
  FETCH = "@@stats/FETCH",
  FETCH_SUCCESS = "@@stats/FETCH_SUCCESS",
  FETCH_ERROR = "@@stats/FETCH_ERROR",
}

export interface StatsState {
  readonly loading: boolean;
  readonly data: Stats | undefined;
  readonly errors?: string;
}
